const benefits = [
  {
    icon: 'ri-star-line',
    title: 'Najlepsze produkty',
    description: 'Kategorie produktów, trendy i popularne wybory starannie wyselekcjonowane przez społeczność Kakobuy.',
  },
  {
    icon: 'ri-guide-line',
    title: 'Kompletne poradniki',
    description: 'Instrukcje krok po kroku, które pomogą Ci sprawnie poruszać się po platformie Kakobuy.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Bezpieczne korzystanie',
    description: 'Dowiedz się jak unikać błędów i bezpiecznie dokonywać zakupów na platformie.',
  },
  {
    icon: 'ri-refresh-line',
    title: 'Aktualne informacje',
    description: 'Regularnie aktualizowane treści, dzięki którym zawsze masz dostęp do najnowszych danych.',
  },
];

export default function WhyChooseSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-8 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            Dlaczego warto wybrać nasz przewodnik?
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            Oferujemy kompletne wsparcie w korzystaniu z Kakobuy Spreadsheet — od podstaw po zaawansowane strategie
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {benefits.map((benefit) => (
            <div
              key={benefit.title}
              className="group p-6 md:p-7 rounded-lg bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-lg bg-accent-100 flex items-center justify-center mb-5 group-hover:bg-accent-200 transition-colors">
                <i className={`${benefit.icon} text-xl text-accent-600`}></i>
              </div>
              <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-900 mb-2">
                {benefit.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}